import { UserPaginationParams } from '../../domain/entities/user-pagination-params.entity';

export class UserPaginationParamsModel extends UserPaginationParams {
  override getPath(): string {
    let url: string = '';

    if (this.userId) {
      url += `${this.userId}?`;
    } else {
      url += '?';
    }

    url += `pagination.IsPaginated=true`;
    url += `&pagination.Page=${this.page}`;
    url += `&pagination.AmountRegistersPage=${this.quantity}`;

    if (this.generalFilter) {
      url += `&search_input=${this.generalFilter}`;
    }

    return url;
  }
  override toJson(): Map<string, any> {
    throw new Error('Method not implemented.');
  }
}
